import { render, staticRenderFns } from "./editMatter.vue?vue&type=template&id=5285aed9"
import script from "./editMatter.vue?vue&type=script&lang=js"
export * from "./editMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports